import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Packages from '../components/Packages';
import HowItWorks from '../components/HowItWorks';
import Statistics from '../components/Statistics';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import { InteractiveEffects } from '../components/InteractiveEffects';
import FellowOfTheWeekCard from '../components/FellowOfTheWeekCard';

export default function Home() {
  return (
    <div className="home" style={{ position: 'relative', overflow: 'hidden' }}>
      <InteractiveEffects />
      <div className="ambient-blob blob-1"></div>
      <div className="ambient-blob blob-2"></div>
      <div className="ambient-blob blob-3"></div>

      <Helmet>
        <title>TeachGenie™.ai - AI Lesson Planner for Teachers</title>
        <meta name="description" content="Generate complete, high-quality lesson plans, PowerPoint presentations, quizzes, and visual diagrams in 1-2 minutes with TeachGenie™.ai's AI for educators." />
      </Helmet>

      <Navbar />

      <Hero />

      <FellowOfTheWeekCard />

      <Features />
      
      <HowItWorks />

      <Statistics />

      <Testimonials />
      
      <Packages />
      
      <CTA />

      <Footer />
    </div>
  );
}
